module.exports = __webpack_public_path__ + "img/catalog_subset_banner_small.5b4bbd9.svg";